export enum ErrorCategory {
  Network = 'Network',
  Auth = 'Auth',
  Permission = 'Permission',
  Server = 'Server',
  Validation = 'Validation',
  Business = 'Business',
  Unknown = 'Unknown',
}

export interface IAppError {
  category: ErrorCategory
  code?: string
  message: string
  fieldName?: string
  originalError?: unknown
}

export interface IFormFieldError {
  field: string
  message: string
}
